import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationPopupComponent } from 'src/app/shared/component/confirmation-popup/confirmation-popup.component';
import { Context } from 'src/app/shared/models/context';
import { Message, Metrics, PrivilegeType } from 'src/app/shared/models/domain';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { MetricsCrudComponent } from '../metrics-crud/metrics-crud.component';
import { SettingsService } from 'src/app/shared/services/settings.service';
@Component({
  selector: 'app-metrics-list',
  templateUrl: './metrics-list.component.html',
  styleUrls: ['./metrics-list.component.scss']
})
export class MetricsListComponent implements OnInit {

  public metrics: Metrics[] = [];
  public searchKeyword: string = "";
  public privilege: PrivilegeType;
  public isLoading: boolean = true;
  public context: Context;

  constructor(
    private commonService: CommonService,
    private modalService: NgbModal,
    private authService: AuthService,
    private settingService: SettingsService,
  ) {}

  ngOnInit(): void {
    this.privilege = this.commonService.getPrivileges('DELETE');
    // this.dataService.privilege().subscribe(privilege => { this.privilege = this.commonService.getPrivileges(privilege) });    
    this.context = this.authService.getContextData();
    this.getmetrics();
  }

  private getmetrics(clear: boolean = true) {
    if (clear) {
      this.isLoading = true;
      this.metrics = [];
    }
    this.settingService.getMetrics().subscribe({
      next: (metrics: Metrics[]) => {
        this.metrics = metrics.sort((a, b) => a.id - b.id);
        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.isLoading = false;
        this.commonService.setToastr(500, error?.error?.name || error.error);
      }
    });
  }

  public deleteMetric(metric: Metrics, index: number) {
    if (!this.privilege.canDelete) return;
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.title = "metric deletion";
    modalRef.componentInstance.prefixMessage = "Are you sure you want to delete metric";
    modalRef.componentInstance.message = metric.name;
    modalRef.componentInstance.label = 'metric';
    modalRef.result.then((isConfirmed: boolean) => {
      if (isConfirmed) {
        // metric.isDeleteInProgress = true;
        this.settingService.deleteMetric(metric.id).subscribe({
          next: (message: Message) => {
            if (!message.failed) {
              this.commonService.setToastr(200, message.text);
              this.metrics.splice(index, 1);
              this.getmetrics();
              // metric.isDeleteInProgress = false;
            } else {
              this.commonService.setToastr(500, message.text);
              // metric.isDeleteInProgress = false;
            }
          },
          error: (error: HttpErrorResponse) => {
            this.commonService.setToastr(500, error?.error?.name || error.error);
            // metric.isDeleteInProgress = false;
          },
        });
      }
    });
  }

  public upsertMetric(metric?: Metrics) {
    if (!this.privilege.canEdit) return;
    const modalRef = this.modalService.open(MetricsCrudComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.metric = metric;
    modalRef.componentInstance.context=this.context;
    modalRef.componentInstance.metrics = this.metrics.filter(t => t.id !== metric?.id);
    // modalRef.componentInstance.users = this.users.filter(r => r.id !== user?.id);
    modalRef.result.then((response: boolean) => {
      if (response==true) {
        this.getmetrics();
      }
    })
  }

  public toggleMetricStatus(metric: Metrics) {
    if (!this.privilege.canEdit) {
      setTimeout(() => { metric.disabled = !metric.disabled }, 0);
      return;
    }
    this.settingService.toggleMetricStatus(metric).subscribe({
      next: (response: Message) => {
        if (!response.failed) {
          this.commonService.setToastr(200, `Metric ${metric.name} is now ${metric.disabled ? 'disabled' : 'enabled'}!`);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.commonService.setToastr(500, error?.error?.name || error.error);
        // metric.isDeleteInProgress = false;
      },
    });
  }
}
